import { Link as RouterLink } from "react-router-dom";

// material-ui
import { Link } from "@mui/material";

// project imports
import { DASHBOARD_PATH } from "@config";
import Logo from "@uiComponent/Logo";
import useAuth from "@hooks/useAuth";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const { user } = useAuth();
  return (
    <Link component={RouterLink} to={user?.is_property ? "/dashboard/orders" : DASHBOARD_PATH}>
      <Logo />
    </Link>
  );
};

export default LogoSection;
